import { AlertCircle } from 'lucide-react';
import { isChrome, isMobile, isSafari } from 'react-device-detect';
import { match } from 'ts-pattern';

import { Alert, AlertDescription } from '@nesso/ui/primitives/alert';

export function RecordingLaunchMicrophoneAccessBlocked() {
    return (
        <div>
            <div className="flex items-center gap-2.5 mb-6">
                <AlertCircle className="w-8 h-8 fill-destructive text-background flex-shrink-0 mt-0.5" />
                <h3 className="text-2xl font-medium text-destructive">
                    Microphone access is blocked
                </h3>
            </div>
            {match({ isMobile, isChrome, isSafari })
                .with({ isMobile: false, isChrome: true }, () => (
                    <div className="space-y-4 text-md text-foreground">
                        <img
                            src="/instructions/microphone-permission-chrome.png"
                            alt="How to enable microphone access in Chrome"
                            width={330}
                            height={143}
                            className="my-6"
                        />
                        <p className="text-md">
                            We need access to your microphone to generate a note
                        </p>
                        <ol className="list-decimal list-outside ml-5 space-y-4">
                            <li>
                                Click on the icon to left of the website's address in the top bar of
                                your browser.
                            </li>
                            <li>
                                Find the "Microphone" setting
                                <p>
                                    Turn the gray "Not allowed" switch to "Allowed" (it will turn
                                    blue).
                                </p>
                            </li>
                            <li>Refresh your page.</li>
                        </ol>
                    </div>
                ))
                .with({ isMobile: false, isSafari: true }, () => (
                    <div className="space-y-4 text-md text-foreground">
                        <img
                            src="/instructions/microphone-permission-safari.png"
                            alt="How to enable microphone access in Safari"
                            width={224}
                            height={173}
                            className="my-6 mx-auto"
                        />
                        <ol className="list-decimal list-outside ml-4 space-y-4">
                            <li>
                                Go to the menu bar at the top of your screen and click on{' '}
                                <b>Safari</b>
                            </li>
                            <li>
                                From the dropdown menu, select <b>Settings</b> for{' '}
                                <b>
                                    {import.meta.env.VITE_SITE_URL?.split('//')[1] ||
                                        'nesso.nessoapp.com'}
                                </b>
                                <p>
                                    If the switch next to it is gray and says "Not allowed," click
                                    the switch to turn it on. It should turn blue and now say
                                    "Allowed."
                                </p>
                            </li>
                            <li>
                                Change <b>Microphone</b> setting to <b>Allow</b>
                            </li>
                            <li>Refresh your page</li>
                        </ol>
                    </div>
                ))
                .otherwise(() => (
                    <Alert variant="destructive" aria-label="Microphone access is blocked">
                        <AlertDescription>
                            We need access to your microphone to generate a note
                        </AlertDescription>
                    </Alert>
                ))}
        </div>
    );
}
